<div class="specialities">
    <div class="title">
        <div class="tit">
            <h3>ÁRLISTA MÓDOSÍTÁSA</h3>
            <!-- <div class="add-icon">
      <mat-icon routerLink="/addspeciality">add_circle</mat-icon>
    </div> -->
        </div>
    </div>

    <div class="add-new-speciality">
        <div class="search-bar">
            <div class="search-tool">
                <input type="search" placeholder="Szakterület neve" [(ngModel)]="searchText" />
                <div class="icon">
                    <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search" />
                </div>
            </div>
        </div>
    </div>
    <div class="speciality-container">
        <div class="speciality-c">
            @for (speciality of specialities | filter: searchText; track speciality; let i = $index) {
                <div class="speciality">
                    <div class="pro">
                        <div
                            class="name"
                            [ngStyle]="
                                i % 2 === 0 ? { background: 'white', border: '1px solid #ccc' } : { background: '#efeff5', border: 'black' }
                            "
                        >
                            @if (speciality.examinationList?.length! > 0) {
                                <div
                                    [routerLink]="'/pricelist/' + speciality.routerLink"
                                    class="button"
                                    [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }"
                                >
                                    {{ speciality.name }} árlista módosítása
                                </div>
                            }
                            @if (speciality.examinationList?.length! === 0) {
                                <div class="button" [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }">
                                    <b>{{ speciality.name }} árlista (nincs benne tétel)</b>
                                </div>
                            }
                            <div class="add-icon" [ngStyle]="{ 'align-self': 'center', 'padding-left': '8px', 'padding-right': '8px' }">
                                <mat-icon
                                    [routerLink]="'/addexamination/' + speciality.routerLink"
                                    [ngStyle]="{ cursor: 'pointer', border: 'none', background: 'none' }"
                                    >add_circle</mat-icon
                                >
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
